import Button from 'components/atoms/Button/Button';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import TranslationWrapper from 'components/templates/Translation/TranslationWrapper';
import React from 'react';
import classes from './ErrorPage.module.scss';
import ScheduledMaintenance from 'components/assets/scheduled-maintenance.svg';
import Frown from 'components/assets/frown.svg';
import Crosshair from 'components/assets/Crosshair.svg';

export interface Props {
  statusCode?: number;
  errorMessage?: string;
}

const ErrorPage: React.FC<Props> = ({ statusCode, errorMessage }) => {
  return (
    <TranslationWrapper namespace="common">
      <article className={classes.inner}>
        {statusCode === 403 && <AccessDenied />}
        {statusCode === 404 && <NotFound />}
        {statusCode !== 403 && statusCode !== 404 && <Maintenance errorMessage={errorMessage} />}
      </article>
    </TranslationWrapper>
  );
};
export default ErrorPage;

function NotFound() {
  const handleReload = () => {
    window.location.reload();
  };
  return (
    <>
      <Heading level={1} className={classes.heading}>
        Page not found
      </Heading>
      <Crosshair alt="crosshair with question mark in center" width={88} height={88} />
      <Txt size="large">
        We can&apos;t seem to find the page you&apos;re looking for. Let&apos;s find a better place
        for you to go.
      </Txt>
      <Button buttonType="primary" onClick={handleReload} buttonSize="large">
        <Txt>Reload Page</Txt>
      </Button>
    </>
  );
}

function AccessDenied() {
  return (
    <>
      <Heading level={1} className={classes.heading}>
        Content unavailable!
      </Heading>
      <Frown alt="frowning face" width={80} height={80} />
      <Txt size="large">Sorry! This content is not available where you are.</Txt>
    </>
  );
}
function Maintenance({ errorMessage }: { errorMessage?: string }) {
  return (
    <>
      <Heading level={1} className={classes.heading}>
        We&apos;ll be back soon!
      </Heading>
      <ScheduledMaintenance alt="spanner icon" width={80} height={80} />
      <Txt size="large" skipTranslation={!!errorMessage}>
        {errorMessage ||
          `We're currently performing scheduled maintenance to improve the Mobiworkx website. We'll be back
        online shortly!`}
      </Txt>
    </>
  );
}
